import { TFile, TFileSecure } from 'data/types/Storage.types';
import { EStorageUrls } from 'data/urls/storage.url';

import { authSplitApi } from '../helpers/slice.helpers';

const formDataCreator = (data: { file: File; category: string }) => {
  const formData = new FormData();
  formData.append('file', data.file);
  formData.append('category', data.category);
  return formData;
};

export const storageApi = authSplitApi('storage', ['files'], 'common').injectEndpoints({
  endpoints: build => ({
    uploadFile: build.mutation<TFile, FormData>({
      query(body) {
        return {
          url: `${EStorageUrls.STORAGE}/${EStorageUrls.FILES}`,
          method: 'POST',
          body,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const storageAdminApi = authSplitApi('storageAdmin', ['filesSecure'], 'admin').injectEndpoints({
  endpoints: build => ({
    uploadFileSecure: build.mutation<TFileSecure, { file: File; category: string }>({
      query(body) {
        return {
          url: `${EStorageUrls.STORAGE}/${EStorageUrls.FILES_SECURE}`,
          method: 'POST',
          body: formDataCreator(body),
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useUploadFileMutation } = storageApi;
export const { useUploadFileSecureMutation } = storageAdminApi;
